import { SET_CHATBOT_VISIBILITY } from "./actionTypes";

import produce from "immer";

const initialState = {
  chatBoxVisibility: "minimized",
};

const contactReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_CHATBOT_VISIBILITY:
      return { ...state, chatBoxVisibility: payload };
    default:
      return state;
  }
});

export default contactReducer;
